import { call, put, takeEvery, select } from 'redux-saga/effects';

import {
  fetchExperiencesSuccess,
  fetchExperiencesFailure,
  completeExperienceSuccess,
  completeExperienceFailure,
} from './actions';
import { getAllExperiences, completeExperience } from './api';
import { EXPERIENCES_FETCH, EXPERIENCE_COMPLETE } from './types';

function* experiencesFetchSaga() {
  try {
    const { data: experiences } = yield call(getAllExperiences);
    yield put(fetchExperiencesSuccess(experiences));
  } catch (e) {
    yield put(fetchExperiencesFailure(e));
  }
}

function* experienceCompleteSaga(action) {
  try {
    const { key } = action.payload;
    const { id } = yield select(
      (state) => (state as any).ftue.experiences[key]
    );
    const { data: experience } = yield call(completeExperience, id);
    yield put(completeExperienceSuccess(experience));
  } catch (e) {
    yield put(completeExperienceFailure(e));
  }
}

export default function* saga() {
  yield takeEvery(EXPERIENCES_FETCH, experiencesFetchSaga);
  yield takeEvery(EXPERIENCE_COMPLETE, experienceCompleteSaga);
}
